//import node modules and react modules
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import * as Icons from "react-icons/fa";
import { BsTable, BsCalendar3 } from "react-icons/bs";
import { BsDatabaseFillX } from "react-icons/bs";
import { BsDatabaseFillCheck } from "react-icons/bs";
import { Link } from 'react-router-dom';
//import DWBO sources
import Headline from '../../components/Headline';
import { useSelector } from 'react-redux';
import { getFormConfig, getToken, getUser } from '../../features/user/userSlice';

/**
 * @author Vanessa Plaschnick
 */
function HomePage() {
    const user = useSelector(getUser);
    const userToken = useSelector(getToken);
    const fullFormConfig = useSelector(getFormConfig);

    const findFormConfig = () => {
        let configName = "dataCollection";

        if (user.userProject.projectType.id === 2) {
            const offerType = user.userProject.projectOffer.projectOfferType?.toLowerCase();

            if (offerType && offerType.includes("freizeitangebot")) {
                configName = configName + "LeisureTime";
            }
        }
        return fullFormConfig[configName];
    }

    const [formConfig, setFormConfig] = useState(findFormConfig());
    const projectModel = user.userProject.projectType.id;
    const projectType = user.userProject.projectType.projectTypeDescription;
    //const projectOfferType = user.userProjectprojectOffer.projectOfferTypeID;

    switch (projectModel) {
        //WLH
        case 1:
            return (
                <div id="menu-options">
                    <Headline name='Startseite' area={projectType} />
                    <div>
                        <div className='row'>
                            <Link className="card-link" to="/user/dataCollection">
                                <Card className='dwbo-card' style={{ width: '100%' }}>
                                    <Card.Header>Datenerfassung</Card.Header>
                                    <Card.Body>
                                        <Card.Title><Icons.FaDatabase size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                        <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/report">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Strukturierter Sachbericht Teil C</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaChartBar size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/clientView">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Klient*innenübersicht</Card.Header>
                                        <Card.Body>
                                            <Card.Title><BsTable size={68} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/excel-export">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Excel-Bericht zur projektinternen Verwendung</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaFileExcel size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/project">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Projektdaten</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaProjectDiagram size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div>
                        {/* <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/services">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Leistungen ohne Klient*innenbezug</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaUsers size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/import">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Datenübernahme</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaFileImport size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div> */}
                    </div>
                </div>
            );
        //BH
        case 2:
            return (
                <div id="menu-options" className='bh-menu'>
                    <Headline name='Startseite' area={projectType} />
                    <div>
                        <div className='row menu-data-collect'>
                            <Link className="card-link" to="/user/anonymousCollection">
                                <Card className='dwbo-card' style={{ width: '100%' }}>
                                    <Card.Header>Nicht-personenbezogene Leistungen</Card.Header>
                                    <Card.Body>
                                        <Card.Title><BsDatabaseFillX size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                            <Link className="card-link" to="/user/dataCollection">
                                <Card className='dwbo-card' style={{ width: '100%' }}>
                                    <Card.Header>Erfassung personenbezogener Daten</Card.Header>
                                    <Card.Body>
                                        <Card.Title><BsDatabaseFillCheck size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '1.25em' }}>
                        <div className='col'>
                            <Link className="card-link" to="/user/event">
                                <Card className='dwbo-card'>
                                    <Card.Header>Veranstaltungen</Card.Header>
                                    <Card.Body>
                                        <Card.Title><BsCalendar3 size={68} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                        <div className='col'>
                            <Link className="card-link" to="/user/clientView">
                                <Card className='dwbo-card'>
                                    <Card.Header>Klient*innenübersicht</Card.Header>
                                    <Card.Body>
                                        <Card.Title><BsTable size={68} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '1.25em' }}>
                        <div className='col'>
                            <Link className="card-link" to="/user/report">
                                <Card className='dwbo-card'>
                                    <Card.Header>Strukturierter Sachbericht Teil C</Card.Header>
                                    <Card.Body>
                                        <Card.Title><Icons.FaChartBar size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                        <div className='col'>
                            <Link className="card-link" to="/user/project">
                                <Card className='dwbo-card'>
                                    <Card.Header>Projektdaten</Card.Header>
                                    <Card.Body>
                                        <Card.Title><Icons.FaProjectDiagram size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '1.25em' }}>
                        <div className='col'>
                            <Link className="card-link" to="/user/excel-export">
                                <Card className='dwbo-card'>
                                    <Card.Header>Excel-Bericht zur projektinternen Verwendung</Card.Header>
                                    <Card.Body>
                                        <Card.Title><Icons.FaFileExcel size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                        <div className='col'> </div>
                    </div>
                    {/* <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/services">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Leistungen ohne Klient*innenbezug</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaUsers size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/import">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Datenübernahme</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaFileImport size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div> */}
                </div>
                /*</div>*/
            );

        // SFH
        case 3:
            return (
                <div id="menu-options">
                    <Headline name='Startseite' area={projectType} />
                    <div>
                        <div className='row'>
                            <Link className="card-link" to="/user/dataCollection">
                                <Card className='dwbo-card' style={{ width: '100%' }}>
                                    <Card.Header>Datenerfassung</Card.Header>
                                    <Card.Body>
                                        <Card.Title><Icons.FaDatabase size={70} /></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </div>
                        <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/report">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Strukturierter Sachbericht Teil C</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaChartBar size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/clientView">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Klient*innenübersicht</Card.Header>
                                        <Card.Body>
                                            <Card.Title><BsTable size={68} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/excel-export">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Excel-Bericht zur projektinternen Verwendung</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaFileExcel size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/project">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Projektdaten</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaProjectDiagram size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div>
                        {/* <div className='row' style={{ marginTop: '1.25em' }}>
                            <div className='col'>
                                <Link className="card-link" to="/user/services">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Leistungen ohne Klient*innenbezug</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaUsers size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                            <div className='col'>
                                <Link className="card-link" to="/user/import">
                                    <Card className='dwbo-card'>
                                        <Card.Header>Datenübernahme</Card.Header>
                                        <Card.Body>
                                            <Card.Title><Icons.FaFileImport size={70} /></Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </div>
                        </div> */}
                    </div>
                </div>
            );

        default: return null;
    }
}

export default HomePage;